import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { getMuiButtonProps } from "./buttonVariants";
import { cx } from "../utils";

const VARIANT_CLASS = {
  primary: "cc-button--primary",
  secondary: "cc-button--secondary",
  ghost: "cc-button--ghost",
  danger: "cc-button--danger",
  dangerOutline: "cc-button--danger-outline",
  ai: "cc-button--ai",
};

const SIZE_CLASS = {
  sm: "cc-button--sm",
  small: "cc-button--sm",
  lg: "cc-button--lg",
  large: "cc-button--lg",
};

const useStyles = makeStyles(() => ({
  root: {
    minWidth: "unset",
    boxShadow: "none",
    textTransform: "none",
    fontWeight: 700,
    letterSpacing: 0,
    lineHeight: 1,
    "&:hover": {
      boxShadow: "none",
    },
    "& .MuiButton-startIcon": {
      marginLeft: 0,
      marginRight: 8,
    },
    "& .MuiButton-endIcon": {
      marginLeft: 8,
      marginRight: 0,
    },
  },
}));

/**
 * Carecentre Zen button — styles from tokens.css (.cc-button--*).
 * Variants: primary, secondary, ghost, danger, dangerOutline, ai.
 * Sizes: sm/small, md/medium/default, lg/large.
 */
const CcButton = ({
  variant = "primary",
  size = "md",
  className,
  children,
  ...props
}) => {
  const classes = useStyles();
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  const sizeClass = SIZE_CLASS[size] || null;

  return (
    <Button
      disableElevation
      disableRipple
      {...getMuiButtonProps(variant, size)}
      className={cx(
        "cc-button",
        variantClass,
        sizeClass,
        classes.root,
        className,
      )}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CcButton;
